import React, { CSSProperties, Suspense, useState } from 'react';
import C from './SpaceCard.css';
import backgroundImage from '../../assets/images/icon--cocospace-light.svg';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import NewSpaceModal from 'components/new-space-modal/NewSpaceModal';
import { useParams } from 'react-router-dom';
import { useCommunityDetails } from 'atoms/community-details';
import { DashboardParams } from 'constants/routes';
import { Trans } from '@lingui/macro';

export default function NewSpaceCard(p: { style?: CSSProperties }) {
  const [isCreatingSpace, setCreatingSpace] = useState(false);
  const { communityId } = useParams<DashboardParams>();
  const { community } = useCommunityDetails({
    communityId,
    autoLoad: false,
  });

  const containerWidth =
    typeof p.style?.width === 'number' ? (p.style.width as number) : 237;
  const previewHeight = Math.round((containerWidth * 3) / 4);

  return (
    <div
      className={C.cardContainer}
      style={{
        width: containerWidth + 'px',
        // Allow the + button to hang half outside the card
        overflow: 'visible',
        ...p.style,
      }}
    >
      {isCreatingSpace && (
        <Suspense fallback={null}>
          <NewSpaceModal
            onClose={() => {
              setCreatingSpace(false);
            }}
            onSuccess={() => {
              setCreatingSpace(false);
            }}
            defaultCommunityId={community?.id}
          />
        </Suspense>
      )}

      <div
        className={C.cardPreview}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'center center',
          backgroundSize: '30%',
          backgroundColor: 'var(--color-base)',
          cursor: 'pointer',
          height: previewHeight + 'px',
          flexBasis: previewHeight + 'px',
        }}
        onClick={() => {
          setCreatingSpace(true);
        }}
      ></div>
      <div className={C.cardDetails}>
        <div
          style={{
            textAlign: 'center',
            color: 'var(--color-text)',
            fontWeight: 'var(--font-weight-bold)',
            paddingTop: '8px',
          }}
        >
          <Trans>Create CoCo Space</Trans>
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '-20px',
          textAlign: 'center',
          left: 0,
          right: 0,
        }}
      >
        <IconButton
          style={{
            margin: 'auto',
            background: 'var(--color-selected)',
          }}
          onClick={() => {
            setCreatingSpace(true);
          }}
        >
          <AddIcon />
        </IconButton>
      </div>
    </div>
  );
}
